import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PropTypes from 'prop-types';
import { formatDateTime } from '../../../../shared/utils/date';
import SmallLoader from '../../../../components/SmallLoader';
import { renderPaginationShowsTotal } from '../../../../shared/utils/table';
import map from 'lodash/map';
import { Link } from 'react-router';

const recoveryActionsFormatter = (cell, row) => {
    let recoveryActions = [];

    if (
        row.manifest &&
        row.manifest.allManifestRecoveryActions &&
        row.manifest.allManifestRecoveryActions.length > 0
    ) {
        recoveryActions = row.manifest.allManifestRecoveryActions;
    } else if (row.allManifestRecoveryActions && row.allManifestRecoveryActions.length > 0) {
        recoveryActions = row.allManifestRecoveryActions;
    } else {
        recoveryActions = row.recoveryActions;
    }

    if (recoveryActions && recoveryActions.length > 0) {
        return (
            <div>
                {map(recoveryActions, rec => {
                    if (rec.recoveryActionId && rec.abnormalityRun) {
                        let runId = rec.abnormalityRun.runId;
                        let abnormalityType = rec.abnormality.abnormalityType;
                        let abnormalityId = rec.abnormality.abnormalityId;
                        return (
                            <p key={rec.recoveryActionId}>
                                <Link
                                    to={`runs/${runId}/abnormality/${abnormalityType}/${abnormalityId}/recoveryAction/${
                                        rec.recoveryActionType
                                    }/${rec.recoveryActionId}`}
                                >
                                    {rec.name}
                                </Link>
                            </p>
                        );
                    }
                })}
            </div>
        );
    }

    return '';
};

const abnormalitiesFormatter = (cell, row) => {
    let abnormalities = [];

    if (
        row.manifest &&
        row.manifest.allManifestAbnormality &&
        row.manifest.allManifestAbnormality.length > 0
    ) {
        abnormalities = row.manifest.allManifestAbnormality;
    } else if (row.allManifestAbnormality && row.allManifestAbnormality.length > 0) {
        abnormalities = row.allManifestAbnormality;
    } else {
        abnormalities = row.abnormalities;
    }

    if (abnormalities && abnormalities.length > 0) {
        return (
            <div>
                {map(abnormalities, abn => {
                    if (abn.abnormalityId) {
                        let abnormalityType = abn.abnormalityType;
                        let abnormalityId = abn.abnormalityId;
                        let root = abn.genericAbnormalityType === 'MANIFEST_BASED'
                            ? 'manifests/' + row.manifestId
                            : 'runs/' + abn.runId;
                        return (
                            <p key={abn.abnormalityId}>
                                <Link
                                    to={`${root}/abnormality/${abnormalityType}/${abnormalityId}`}
                                >
                                    {abn.name}
                                </Link>
                            </p>
                        );
                    }
                })}
            </div>
        );
    }

    return '';
};

const formatGhost = ghostValue => {
    return ghostValue  ? 'True' : 'False';
}

const manifestNumberFormatter = (cell, row, noManifestLink) => {
    if (noManifestLink) {
        if (row.manifestId) {
            return row.manifestNumber;
        }
    } else {
        return <Link to={`manifests/${row.manifestId}`}>{row.manifestNumber}</Link>;
    }
};
class ManifestsTable extends React.Component {
    render() {
        const {
            isFetching,
            isSelectable,
            isRadioSelect,
            manifests,
            isPaginated = true,
            noManifestLink = false,
            onCheckSelect,
            onCheckSelectAll,
            selectedManifests,
            validations,
            sortName,
            sortOrder,
        } = this.props;

        const options = {
            sizePerPage: 10,
            sizePerPageList: [10, 25, 50, 100],
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
            paginationShowsTotal: renderPaginationShowsTotal,
            defaultSortName: sortName,
            defaultSortOrder: sortOrder,
            noDataText: isFetching ? (
                <SmallLoader />
            ) : (
                'No data to display. Please refine your search.'
            ),
        };
        return (
            <div>
                {validations &&
                    validations.manifests && (
                        <p style={{ color: '#CF142B', margin: 5 }}>{validations.manifests}</p>
                    )}
                <BootstrapTable
                    data={manifests}
                    options={options}
                    pagination={isPaginated}
                    hover
                    tableStyle={
                        validations && validations.manifests && { border: '#CF142B 2px solid' }
                    }
                    trClassName={!isSelectable && 'clickable'}
                    selectRow={
                        isSelectable && {
                            mode: isRadioSelect ? 'radio' : 'checkbox',
                            onSelect: onCheckSelect,
                            onSelectAll: onCheckSelectAll,
                            selected: selectedManifests,
                        }
                    }
                >
                    <TableHeaderColumn dataField="manifestId" isKey hidden>
                        Manifest ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        ref="manifestNumber"
                        dataField="manifestNumber"
                        dataFormat={(cell, row) =>
                            manifestNumberFormatter(cell, row, noManifestLink)
                        }
                        dataSort
                    >
                        Manifest number
                    </TableHeaderColumn>
                    <TableHeaderColumn ref="emcCode" dataField="emcCode" dataSort>
                        EMC code
                    </TableHeaderColumn>
                    <TableHeaderColumn ref="emcPlantCode" dataField="emcPlantCode" dataSort>
                        EMC plant
                    </TableHeaderColumn>
                    <TableHeaderColumn ref="emcDockCode" dataField="emcDockCode" dataSort>
                        EMC dock
                    </TableHeaderColumn>
                    <TableHeaderColumn ref="supplierCode" dataField="supplierCode" dataSort>
                        Supplier
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        ref="supplierPlantCode"
                        dataField="supplierPlantCode"
                        dataSort
                    >
                        Supplier plant
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        ref="ghost"
                        dataField="ghost"
                        dataFormat={formatGhost}
                        dataSort
                    >
                        Ghost
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        ref="pLaneExit"
                        dataField="pLaneExit"
                        dataFormat={formatDateTime}
                        dataSort
                    >
                        P-Lane exit
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        hidden={noManifestLink}
                        dataField="allManifestRecoveryActions"
                        dataFormat={recoveryActionsFormatter}
                        editable={false}
                        dataSort
                    >
                        Existing recovery actions
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        hidden={noManifestLink}
                        dataField="allManifestAbnormality"
                        dataFormat={abnormalitiesFormatter}
                        editable={false}
                        dataSort
                    >
                        Existing Abnormalities
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

ManifestsTable.propTypes = {
    isPaginated: PropTypes.bool,
    isRadioSelect: PropTypes.bool,
    isSelectable: PropTypes.bool,
    onCheckSelect: PropTypes.func,
    onCheckSelectAll: PropTypes.func,
    selectedManifests: PropTypes.array,
};

export default ManifestsTable;
